import { CongratsView } from './CongratsView'

export const Payment = () => {
    return <CongratsView />
}
